import React from "react";
import { t } from "../../../utils/i18n";

const Head = () => (
  <thead class="table-header rounded-top">
    <tr>
      <th>{t("account.activities.date")}</th>
      <th>{t("account.activities.amount")}</th>
      <th>{t("account.activities.type")}</th>
      <th>{t("account.activities.description")}</th>
      <th>{t("account.activities.status")}</th>
      <th></th>
    </tr>
  </thead>
);

export default Head;
